import React from 'react'

import { useState, useEffect, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

import Banner from "./BannerComponent";
import InputAResultado from './InputAResultadoComponent';


function MainModal() {
  const [ isOpen, setIsOpen ] = useState(true);
  
  const [ data, setData ] = useState([]);


  function closeModal() {
    /** Se comenta para que no se cierra el modal al 
     * hacer click por fuera del mismo
     */
    // setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  // Funcion para Data.json
  const getData = () => {
    fetch("./Data.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
          setData(myJson);
      });
  };

  useEffect(() => {
    getData();

  }, []);

  return (
    <>
      {/* <div className={"fixed inset-0 flex items-center justify-center"}>
        <button
          type={"button"}
          onClick={openModal}
          className={`px-4 py-2 text-sm font-medium text-white bg-dpecGreen rounded-md bg-opacity-100 hover:bg-opacity-70 
                      focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`
                    }
        >
          Abrir Simulador
        </button>
      </div> */}

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as={"div"}
          id={"mainModal"}
          className={"fixed inset-0 z-10 overflow-y-auto w-screen h-screen"}
          onClose={closeModal}
        >
          <div className={"min-h-screen text-center"}>
            <Transition.Child
              as={Fragment}
              enterFrom={"opacity-0"}
              enterTo={"opacity-100"}
              leave={"ease-in duration-200"}
              leaveFrom={"opacity-100"}
              leaveTo={"opacity-0"}
            >
              <Dialog.Overlay className={"fixed inset-0 bg-black opacity-30"} />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className={"inline-block h-screen align-middle"}
              aria-hidden={"true"}
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enterFrom={"opacity-0 scale-95"}
              enterTo={"opacity-100 scale-100"}
              leave={"ease-in duration-200"}
              leaveFrom={"opacity-100 scale-100"}
              leaveTo={"opacity-0 scale-95"}
            >
              <div className={`inline-block w-full max-w-6xl p-0 md:my-8 overflow-hidden text-left align-middle transition-all 
                                transform bg-white opacity-100 shadow-xl rounded-sm`
                              }
              >
                <Dialog.Title>
                  <Banner 
                    closeModal={closeModal}
                  />
                </Dialog.Title>
                <div className={"p-2"}>
                  <InputAResultado closeModal={closeModal} data={data} />
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default MainModal
